import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'required')?_c(VChip,{staticClass:"pa-1",attrs:{"x-small":"","label":"","color":"red accent-1","text-color":"white"}},[_vm._v(" 必須 ")]):_vm._e(),(_vm.type === 'option')?_c(VChip,{staticClass:"pa-1",attrs:{"x-small":"","label":"","color":"grey lighten-1","text-color":"white"}},[_vm._v(" 任意 ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }